module.exports = "/images/nav-bkgrd-eclipse.png?22f9c307d26ad313cd20e03b4d69bc62";